<template>
  <result-wrapper :element-data="elementData" :icon-name="iconName">
    <template #small-view>
      <small-view-result 
          :icon-name="iconName || flagName" 
          @click="openDialog"
        />
        <ai-overview-dialog :html="dialogHtml" @hideDialog="hideDialog" :show="showDialog" />
    </template>
    <div>
      <img class="card-image" :src="AiOverviewLogo" @click="openDialog" />
    </div>
    <ai-overview-dialog :html="dialogHtml" @hideDialog="hideDialog" :show="showDialog" />
  </result-wrapper>
</template>

<script>
import ResultWrapper from "@/components/card/ResultWrapper.vue";
import AiOverviewDialog from "@/components/card/AiOverviewDialog.vue";
import { mapGetters } from "vuex";
import { unref } from "vue";
import SmallViewResult from "../SmallViewResult.vue"
import { detailsPollid, loadResultHtml } from "@/utils/resultHtml";

export default {
  name: "AiOverview",
  inject: {
    cardMetaRef: { from: 'cardMeta', default: () => ({}) }
  },
  props: {
    elementData: Object,
  },
  components: {
    ResultWrapper,
    AiOverviewDialog,
    SmallViewResult
  },
  data() {
    return {
      AiOverviewLogo: require('@/assets/images/ai-overview-logo.png'),
      showDialog: false,
      fetchedHtml: "",
      loadingHtml: false,
    }
  },
  methods: {
    openDialog() {
      if (this.highlightMode || this.loadingHtml) {
        return;
      }
      // DM-10753: /timeline sends `hasHtml`; the html itself is fetched per poll on first open
      const pollid = detailsPollid(this.cardMeta, this.view);
      if (this.dialogHtml || !this.elementData.standard?.hasHtml || !pollid) {
        this.showDialog = true;
        return;
      }
      this.loadingHtml = true;
      loadResultHtml(this.$api, pollid, this.client?.clientid)
        .then((html) => {
          this.fetchedHtml = html.aioverview || "";
          this.showDialog = true;
        })
        .catch((error) => console.error("AI overview html failed to load", error))
        .finally(() => { this.loadingHtml = false; });
    },
    hideDialog() {
      this.showDialog = false;
    },
  },

  computed: {
    ...mapGetters("toolbar", {
      zoomSelection: "zoomSelection",
    }),
    ...mapGetters("routeParams", {
      client: "client",
      view: "view",
    }),
    cardMeta() {
      return unref(this.cardMetaRef) || {};
    },
    dialogHtml() {
      return this.elementData.standard?.html || this.fetchedHtml;
    },
    displayName() {
      return 'Ai Overview';
    },
    iconName() {
      if (this.zoomSelection === 'small-view') {
        return 'ai-overview';
      }
      return '';
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-image {
  width: 70%;
}

.card-image,
.small-view-result {
  cursor: pointer;
}
</style>
